import { render, staticRenderFns } from "./OsobaCreate.vue?vue&type=template&id=dbb36188&scoped=true&"
import script from "./OsobaCreate.vue?vue&type=script&lang=js&"
export * from "./OsobaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb36188",
  null
  
)

export default component.exports